import styled from 'styled-components';

export const Container = styled.div`
  &.WhyTrovaWrapper{
    margin-top: 108px;
    width: 100%;
    display: flex;
  }
  &.WhyTrovaLeftBlock{
    position: relative;
  }
  &.WhyTrovaRightBlock{
    @media screen and (min-width: 992px) {
      background: linear-gradient(180deg, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 100%), rgba(234, 244, 252, 0.7);
      border-radius: 20px;
      padding: 55px 50px 55px 200px;
    }
  }
  &.WhyTrovaItemsBlock{
    display: grid;
    grid-template-columns: 1fr;
    column-gap: 2rem;
    row-gap: 2rem;
    
    @media screen and (min-width: 768px) {
      grid-template-columns: 1fr 1fr;
    }
  }
  & .headline{
    margin-top: 40px;
  }
`;

export const WhyTrovaH2 = styled.h2`
  font-family: Manrope, Helvetica, "Helvetica Neue", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 36px;
  line-height: 135%;
  color: #2C2B48;
  text-align: center;
  margin-top: 40px;
`;

export const StyledImg = styled.img`
  max-width: 100%;

  &.WhyTrovaStandingMan{
    -webkit-transform: scaleX(-1);
    transform: scaleX(-1);
    position: absolute;
    top: 200px;
    left: 38%;
    max-width: 410px;
    z-index: 1;
  }
`;